import YearAPI from "../api/year";

export const years = {
    state: {
        years: [],
        yearOptions:{
            lineCount:0,
            showDeleted:false,
            orderBy:'name',
            orderDirection:'asc',
            itemsPerPage:10,
            itemAdded:false,
            itemSearched:false
        },
        yearsLoadStatus: 0,
        yearAddStatus: 0,
        yearAddText: "",

        yearEdit: {
            id: 0,
            lp: 0,
            name: '',
            from:'',
            to:'',
            holidays:[],
            default:false,
        },
        yearEditDefault: {
            id: 0,
            lp: 0,
            name: '',
            from:'',
            to:'',
            holidays:[],
            default:false,
        },
        yearEditLoadStatus: 0,
        yearEditStatus: 0,
        yearEditText: "",

        yearDeleteStatus: 0,
        yearDeleteText: "",

    },

    actions: {
        loadYears({ state, commit, dispatch }) {
            commit("setYearsLoadStatus", 1);
                YearAPI.getYears({
                    offset:0,
                    itemsPerPage:state.yearOptions.itemsPerPage, 
                    orderBy:state.yearOptions.orderBy,
                    orderDirection:state.yearOptions.orderDirection,
                    showDeleted:state.yearOptions.showDeleted,
                })
                .then(function(response) {
                    commit("setOptionsItemAddedAndSearchedFalse");
                    commit("setYearLineCount", response.data.lineCount);
                    commit("setYears", response.data.years);
                    dispatch("applyIndexOnYears");
                    commit("setYearsLoadStatus", 2);
                })
                .catch(function() {
                    commit("setYears", []);
                    commit("setYearsLoadStatus", 3);
                });
         
        },
        loadMoreYears({ state, commit, dispatch }) {
            commit("setYearsLoadStatus", 1);
                YearAPI.getYears({
                    offset:state.years.length,
                    itemsPerPage:state.yearOptions.itemsPerPage, 
                    orderBy:state.yearOptions.orderBy,
                    orderDirection:state.yearOptions.orderDirection,
                    showDeleted:state.yearOptions.showDeleted,
                })
                .then(function(response) {
                    commit("setYearLineCount", response.data.lineCount);
                    commit("setYears", _.concat(state.years, response.data.years));
                    dispatch("applyIndexOnYears");
                    commit("setYearsLoadStatus", 2);
                })
                .catch(function() {
                    commit("setYears", []);
                    commit("setYearsLoadStatus", 3);
                });
         
        },
        searchYears({ state, commit, dispatch },data) {
            commit("setYearsLoadStatus", 1);
                YearAPI.searchYears({
                    showDeleted:state.yearOptions.showDeleted,
                    filterableHeaders:data.filterableHeaders,
                    q:data.q
                })
                .then(function(response) {
                    commit("setOptionsItemAddedAndSearchedFalse");
                    commit("setYearSearchedTrue");
                    commit("setYearLineCount", response.data.lineCount);
                    commit("setYears", response.data.years);
                    dispatch("applyIndexOnYears");
                    commit("setYearsLoadStatus", 2);
                })
                .catch(function() {
                    commit("setYears", []);
                    commit("setYearsLoadStatus", 3);
                });
         
        },
        setYearOptions({ state, commit, dispatch },data){
            commit("setYearOptions",data.options);
            dispatch("loadYears");
        },
        applyIndexOnYears({ commit, state, dispatch }) {
            let localYears = state.years;

            var i = 1;
            localYears.forEach(year => {
                year.lp = i;
                i++;
            });

            commit("setYears",localYears);
        },
        addYear({ commit, state, dispatch }, data) {
            commit("setYearAddStatus", 1);
            commit("setYearAddText", "");

            YearAPI.postAddNewYear(
                data.name,
                data.from,
                data.to,
                data.holidays,
                data._default,
            )
                .then(function(response) {
                    commit("setYearAddStatus", 2);
                    commit("setAddedYear",response.data);
                    commit("setYearLineCount", state.yearOptions.lineCount + 1);
                    dispatch("applyIndexOnYears");
                    dispatch("loadMenuDictionariesCount");
                    dispatch("loadYearLookup");
                })
                .catch(function(error) {
                    commit("setYearAddStatus", 3);
                    commit("setYearAddText", error.response.data.errors);
                });
        },

        loadYearEdit({ commit }, data) {
            commit("setYearEditLoadStatus", 1);
            commit("setYearEditStatus", 0);
            commit("setYearEditText", "");

            YearAPI.getYearEdit(data.slug)
                .then(function(response) {
                    commit("setYearEdit", response.data);
                    commit("setYearEditLoadStatus", 2);
                })
                .catch(function() {
                    commit("setYearEdit", {});
                    commit("setYearEditLoadStatus", 3);
                });
        },
        loadYearEditDefault({ commit }) {
            commit("setYearEditDefault");
        },
        loadYearAddDefault({ commit }) {
            commit("setYearAddStatus", 0);
            commit("setYearAddText", "");
        },
        editYear({ commit, state, dispatch }, data) {
            commit("setYearEditStatus", 1);

            YearAPI.putEditYear(
                data.slug,
                data.name,
                data.from,
                data.to,
                data.holidays,
                data._default,
            )
                .then(function(response) {
           
                    commit("setYearEditStatus", 2);
                    commit("setEditedYear",response.data)
                    dispatch("applyIndexOnYears");
                    dispatch("loadYearLookup");
                })
                .catch(function(error) {
                    commit("setYearEditStatus", 3);
                    commit("setYearEditText", error.response.data.errors);
                });
        },
        editYearReactivate({ commit, state, dispatch }, data) {
            commit("setYearEditStatus", 1);
  
            YearAPI.putReactivateYear(data.slug)
                .then(function(response) {
                    commit("setYearEditStatus", 2);
                    commit("setEditedYear",response.data)
                    dispatch("applyIndexOnYears");
                    dispatch("loadMenuDictionariesCount");
                    dispatch("loadYearLookup");
                })
                .catch(function(error) {
                    commit("setYearEditStatus", 3);
                });
        },
        deleteYear({ commit, state, dispatch }, data) {
            commit("setYearDeleteStatus", 1);

            YearAPI.deleteYear(data.slug)
                .then(function(response) {
                    commit("setYearDeleteStatus", 2);
                    if(state.yearOptions.showDeleted){
                        commit("setEditedYear",response.data)
                    }else{
                        commit("setYearLineCount", state.yearOptions.lineCount - 1);
                        commit("setDeletedYear",response.data)
                    }
                    dispatch("loadMenuDictionariesCount");
                    dispatch("loadYearLookup");
                    dispatch("applyIndexOnYears");
                })
                .catch(function() {
                    commit("setYearDeleteStatus", 3);
                });
        },
        forceDeleteYear({ commit, state, dispatch }, data) {
            commit("setYearDeleteStatus", 1);

            YearAPI.forceDeleteYear(data.slug)
                .then(function(response) {
                    commit("setYearDeleteStatus", 2);
                    commit("setYearLineCount", state.yearOptions.lineCount - 1);
                    commit("setDeletedYear",response.data)
                    dispatch("applyIndexOnYears");
                })
                .catch(function() {
                    commit("setYearDeleteStatus", 3);
                });
        },
    },
    mutations: {
        setYearOptions(state,options){
            state.yearOptions = options;
        },
        setYearsLoadStatus(state, status) {
            state.yearsLoadStatus = status;
        },
        setYears(state, years) {
            state.years = years;
        },
        setYearLineCount(state, lineCount) {
            state.yearOptions.lineCount = lineCount;
        },
        setYearAddStatus(state, status) {
            state.yearAddStatus = status;
        },
        setYearAddText(state, text) {
            state.yearAddText = text;
        },
        setYearEdit(state, year) {
            state.yearEdit = year;
        },
        setEditedYear(state, year) {
            var lp = _.find(state.years,{'id':year.id}).lp;
            var index = _.findIndex(state.years,{'id':year.id});
            if(year.default){//main change
                state.years.forEach(element => {
                    element.can_delete = true;
                    element.default = false;
                });
            }
            state.years[index] = year;
            state.years[index].lp = lp;
        },
        setAddedYear(state, year) {
            if(year.default){//main change
                state.years.forEach(element => {
                    element.can_delete = true;
                    element.default = false;
                });
            }
            state.yearOptions.itemAdded = true;
            state.years.push(year);
        },
        setYearSearchedTrue(state) {
            state.yearOptions.itemSearched = true;
        },
        setOptionsItemAddedAndSearchedFalse(state) {
            state.yearOptions.itemAdded = false;
            state.yearOptions.itemSearched = false;
        },
        setDeletedYear(state, year) {
            var index = _.findIndex(state.years,{'id':year.id});
            state.years.splice(index,1);
        },
        setYearEditDefault(state) {
            state.yearEdit = { ...state.yearEditDefault };
        },
        setYearEditStatus(state, status) {
            state.yearEditStatus = status;
        },
        setYearEditText(state, text) {
            state.yearEditText = text;
        },
        setYearEditLoadStatus(state, status) {
            state.yearEditLoadStatus = status;
        },
        setYearDeleteStatus(state, status) {
            state.yearDeleteStatus = status;
        },
        setYearDeletedText(state, text) {
            state.yearDeleteText = text;
        }
    },

    getters: {
        getYearOptions(state){
            return state.yearOptions;
        },
        getYearsLoadStatus(state) {
            return state.yearsLoadStatus;
        },
        getYears(state) {
            return state.years;
        },
        getYearAddStatus(state) {
            return function(){
                return state.yearAddStatus;
            } 
        },
        getYearAddText(state) {
            return state.yearAddText;
        },
        getYearEdit(state) {
            return state.yearEdit;
        },
        getYearEditStatus(state) {
          return function(){
            return state.yearEditStatus;
          }
        },
        getYearEditing(state) {
            return state.yearEdit.id > 0;
        },
        getYearEditText(state) {
            return state.yearEditText;
        },
        getYearEditLoadStatus(state) {
            return state.yearEditLoadStatus;
            
        },
        getYearDeleteStatus(state) {
            return function(){
                return state.yearDeleteStatus;
            }
        },
        getYearDeleteText(state) {
            return state.yearDeleteText;
        }
    }
};
